import { CardData } from '../types/index.js';

export class CardRenderer {
  /**
   * Create HTML element for a card
   */
  static createCardElement(cardData: CardData): HTMLElement {
    const card = document.createElement('div');
    card.className = 'card';
    card.dataset.cardId = cardData.id;

    if (cardData.isFaceUp) {
      card.classList.add(`card-${cardData.color}`);
      card.innerHTML = this.createCardFaceHTML(cardData);
    } else {
      card.classList.add('card-back');
    }

    return card;
  }

  /**
   * Create HTML for card face (when face-up)
   */
  private static createCardFaceHTML(cardData: CardData): string {
    const rankDisplay = this.getRankDisplay(cardData.rank);
    const suitSymbol = cardData.suit;

    return `
      <div class="card-corner-top">
        <span class="card-suit">${suitSymbol}</span><span class="card-rank">${rankDisplay}</span>
      </div>
      <div class="card-suit-center">${suitSymbol}</div>
      <div class="card-corner-bottom">
        <span class="card-suit">${suitSymbol}</span><span class="card-rank">${rankDisplay}</span>
      </div>
    `;
  }

  /**
   * Get display string for rank
   */
  private static getRankDisplay(rank: number): string {
    switch (rank) {
      case 1: return 'A';
      case 11: return 'J';
      case 12: return 'Q';
      case 13: return 'K';
      default: return rank.toString();
    }
  }

  /**
   * Create placeholder element for empty pile
   */
  static createPlaceholderElement(pileType: string): HTMLElement {
    const placeholder = document.createElement('div');
    placeholder.className = 'card-placeholder';
    placeholder.dataset.pileType = pileType;
    return placeholder;
  }

  /**
   * Update card element (flip, etc.)
   */
  static updateCardElement(element: HTMLElement, cardData: CardData): void {
    element.dataset.cardId = cardData.id;
    element.className = 'card';

    if (cardData.isFaceUp) {
      element.classList.add(`card-${cardData.color}`);
      element.innerHTML = this.createCardFaceHTML(cardData);
    } else {
      element.classList.add('card-back');
      element.innerHTML = '';
    }
  }
}
